import PropTypes from 'prop-types'
import React from 'react'
import TextField from '../../molecules/fields/TextField'
import Alert from '../../molecules/Alert'
import QuestionOptionsSection from './QuestionOptionsSection'

const PhoneField = ({ baseName, validate }) => {
  return (
    <div className="grid md:grid-cols-2 gap-4">
      <span>
        <TextField
          label="Etiqueta de la pregunta"
          size="full"
          name={`${baseName}.payload.label`}
          validate={validate}
          margin="none"
          errorClassName="relative inset-0"
          initialValue=""
          capsLockInfo
        />
        <QuestionOptionsSection baseName={baseName} margin="none" size="full" />
      </span>
      <Alert type="info">Se validará que la respuesta contenga solo números.</Alert>
    </div>
  )
}

export default PhoneField

PhoneField.propTypes = {
  baseName: PropTypes.string,
  validate: PropTypes.func
}
